/**
 * This directive will replace an image that failed to load, with a solid colour
 */
import {IToastService} from "../services/ToastService";

export class Toast implements ng.IDirective {
    restrict = 'A';
    scope = {
        toast: '&'
    };
    constructor(protected toastService: IToastService) {
        this.link = ($scope: ng.IScope, element: ng.IAugmentedJQuery,
                     attrs: ng.IAttributes) => {
            element.bind('click', () => {
                toastService.showToast($scope['toast']());
            });

        }
    }

    link: ($scope: ng.IScope, element: ng.IAugmentedJQuery,
           attrs: ng.IAttributes) => void = null;

    static factory(): ng.IDirectiveFactory {
        const directive = (toastService: IToastService) => new Toast(toastService);
        directive.$inject = ['toastService'];
        return directive;
    }
}